import {
    Grid,
    SelectChangeEvent,
    Theme,
    Typography
} from "@mui/material";
import { MFTextField } from "../../../../lib/formik";
import { TextDatePicker } from "../../../onboarding/DatePickerWithTextFeild";
import MFSelectField from "../../../../lib/formik/SelectField";
import {
    useDispatch,
    useSelector
} from "react-redux";
import { RootStateType } from "../../../../redux-store/reducers";
import {
    FormikContextType,
    useFormikContext
} from "formik";
import {
    allowDecimalNumbers,
    preventSpecialCharacters
} from "../../../../utils/utilityFunctions";
import dayjs from "dayjs";
import { CurrencyConversionToWords } from "../commonComponents";
import FormikSearchDropdown from "../../../../lib/formik/FormikSearchDropdown";
import * as yup from 'yup';
import { numberRegex } from "../../../../utils/regex";
import { GetCounterPartyListResponseBody } from "../../../../redux-store/types/orderManagement";
import {
    Dispatch,
    SetStateAction,
} from "react";

export default function UnlistedEquityForm({
    securitiesData,
    fetchSecuritiesData,
    setValidations,
    isLoading,
    setLoadingStatus,
    counterPartyList,
    fetchCounterPartyList
}: {
    securitiesData: Record<string, any>;
    fetchSecuritiesData: (searchInput: string) => void;
    setValidations: (values: Record<string, any>) => void;
    isLoading: boolean;
    setLoadingStatus: Dispatch<SetStateAction<"" | "apiLoading" | "formSubmitting">>;
    counterPartyList: GetCounterPartyListResponseBody;
    fetchCounterPartyList: (searchInput: string) => void;
}): JSX.Element {
    const dispatch = useDispatch();

    const { currencySymbol, locale = "en-IN" } = useSelector((store: RootStateType) => store.currencyInfo);
    const { businessDate = "" } = useSelector((store: RootStateType) => store.navbarInfo);

    const {
        values,
        setFieldValue,
        setTouched,
        resetForm
    }: FormikContextType<Record<string, any>> = useFormikContext();

    const handleTextPaste = (event: React.ClipboardEvent<HTMLInputElement>, fieldName: string) => {
        event.preventDefault()
        const clipboardData = event.clipboardData.getData("text")

        const modifiedText = `${clipboardData ?? ""}`?.replaceAll(",", "")

        setFieldValue(fieldName, modifiedText);
    }

    const handleOrderDateChange = (selectedDate: any) => {
        setFieldValue('orderDate', selectedDate?.isValid() ? selectedDate : "", true)
    }

    const handleSecurityChange = async (selectedObj: Record<string, any>) => {
        if (values?.transactionType === "Sell") {

            const quantitySaleable = (!Number.isNaN(Number(selectedObj?.qtySaleable ?? 0)) ? Number(selectedObj?.qtySaleable ?? 0) : 0)

            // if transaction type is Sell,we modify the validation obj to include the Available Quantity validation for quantity field
            setValidations((prevState: Record<string, any>) => ({
                ...prevState,
                quantity: yup
                    .string()
                    .required("Quantity is required")
                    .test('is-number', 'Quantity should be a valid number', function (value) {
                        return !Number.isNaN(Number(value))
                    })
                    .test('whole-number', 'Quantity should be a valid number', function (value) {
                        return numberRegex.test(`${value ?? ""}`);
                    })
                    .test('transaction-type-sell', `Quantity should be less than or equal to ${quantitySaleable}`, function (value) {
                        return Number(value) <= quantitySaleable
                    })
                ,
            }))
        } else if (values?.transactionType !== "Sell") {

            // if transaction type is Buy,we modify the validation obj to remove the Available Quantity validation for quantity field
            setValidations((prevState: Record<string, any>) => ({
                ...prevState,
                quantity: yup
                    .string()
                    .required("Quantity is required")
                    .test('is-number', 'Quantity should be a valid number', function (value) {
                        return !Number.isNaN(Number(value))
                    })
                    .test('whole-number', 'Quantity should be a valid number', function (value) {
                        return numberRegex.test(`${value ?? ""}`);
                    })
            }))
        }

        resetForm({
            values: {
                ...values,
                security: selectedObj,
                issuer: selectedObj?.issuerName ?? "",
                counterParty: null,
                quantity: "",
                // rate: (!Number.isNaN(Number(selectedObj?.marketPrice ?? 0)) ? Number(selectedObj?.marketPrice ?? 0) : 0)?.toLocaleString(locale, {
                //     minimumFractionDigits: 0,
                //     maximumFractionDigits: 4
                // }),
                rate: "",
                charges: "",
                amount: "",
                // tradeCalculationData: {},
                settlementBankNumber: null,
                settlementBank: "",
                settlementBankIfsc: "",
            }
        })
    }

    const handleTransactionTypeChange = async (event: SelectChangeEvent<unknown>) => {
        resetForm({
            values: {
                ...values,
                transactionType: event.target.value,
                security: null,
                issuer: "",
                counterParty: null,
                quantity: "",
                rate: "",
                charges: "",
                amount: "",
                // tradeCalculationData: {},
                settlementBankNumber: null,
                settlementBank: "",
                settlementMethod: "",
                settlementBankIfsc: ""
            }
        })
    }

    const handleQuantityOnChange = async (event: React.ChangeEvent<any>) => {
        try {
            // setTouched({ quantity: true }, true)

            const { target: fieldTarget } = event;
            const { value: enteredValue } = fieldTarget;

            // const modifiedEnteredValue = enteredValue?.trim() ?? ""

            const formattedRate = Number(`${values?.rate ?? ""}`?.replaceAll(',', ''))

            // if (modifiedEnteredValue.length === 0 || formattedRate === 0) {
            //     return
            // }

            // setLoadingStatus("apiLoading")

            // const payload = {
            //     // TEMP CHANGES
            //     // portfolioId: "TW100026",
            //     // security: "887",
            //     // quantity: Number(enteredValue ?? ""),
            //     // price: 10, //Rate
            //     // transactionType: "Buy"
            //     // TEMP CHANGES

            //     portfolioId: values?.account ?? "",
            //     security: values?.security?.security ?? "",
            //     quantity: Number(modifiedEnteredValue ?? ""),
            //     price: formattedRate, //Rate
            //     transactionType: values?.transactionType ?? ""
            // }
            // const response = await (dispatch(getTradeCalculation(payload)) as unknown as Promise<GetTradeCalculationResponseBody>);

            // if (!response?.isSuccess) {
            //     dispatch(showError(response?.message ?? "No Data Available"))
            // }

            // if (response?.isSuccess) {
            // const formatedCharges = (
            //     (!Number.isNaN(Number(response?.tradeCalculationData?.feeTotalCapPcy ?? 0)) ? Number(response?.tradeCalculationData?.feeTotalCapPcy ?? 0) : 0)
            //     +
            //     (!Number.isNaN(Number(response?.tradeCalculationData?.feeTotalExpPcy ?? 0)) ? Number(response?.tradeCalculationData?.feeTotalExpPcy ?? 0) : 0)
            // )?.toLocaleString(locale, {
            //     minimumFractionDigits: 0,
            //     maximumFractionDigits: 2
            // })

            const formattedCharges = Number(`${values?.charges ?? ""}`?.replaceAll(',', ''))

            let calculatedAmount = Number(`${values?.amount ?? ""}`?.replaceAll(',', ''))

            const areAllFieldsEmpty = `${enteredValue ?? ''}`.length === 0 && `${values?.rate ?? ""}`.length === 0 && `${values?.charges ?? ""}`.length === 0

            // Formula to calculate amount =>
            // Transaction Type: Buy => (Quantity * rate) + charges 
            // Transaction Type: Sell => (Quantity * rate) - charges

            if (!Number.isNaN(Number(enteredValue)) &&
                !Number.isNaN(Number(formattedRate)) &&
                !Number.isNaN(Number(formattedCharges))
            ) {
                if (values.transactionType === "Buy") {
                    calculatedAmount = (Number(enteredValue) * formattedRate) + formattedCharges
                }
                if (values?.transactionType === "Sell") {
                    calculatedAmount = (Number(enteredValue) * formattedRate) - formattedCharges
                }
            }

            resetForm({
                values: {
                    ...values,
                    quantity: enteredValue,
                    // tradeCalculationData: response?.tradeCalculationData ?? {},
                    amount: areAllFieldsEmpty
                        ? ""
                        : Number(calculatedAmount)?.toLocaleString(locale, {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 2
                        })
                    // amount: (!Number.isNaN(Number(response?.tradeCalculationData?.netAmountTcy ?? 0)) ? Number(response?.tradeCalculationData?.netAmountTcy ?? 0) : 0)?.toLocaleString(locale, {
                    //     minimumFractionDigits: 0,
                    //     maximumFractionDigits: 2
                    // }),
                    // charges: formatedCharges
                }
            })
            // }
        } catch (error) {
            console.log((error as Error)?.message ?? "");
        } finally {
            setLoadingStatus("")
        }
    }

    const handleRateOnChange = async (event: React.ChangeEvent<any>) => {
        try {
            // setTouched({ rate: true }, true)

            const { target: fieldTarget } = event;
            const { value: enteredValue } = fieldTarget;

            // const modifiedEnteredValue = enteredValue?.trim() ?? ""

            const formattedModifiedEnteredValue = Number(enteredValue ?? "")?.toLocaleString(locale, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 4
            })

            // if (
            //     (Number.isNaN(Number(modifiedEnteredValue))) ||
            //     modifiedEnteredValue.length === 0 ||
            //     Number(modifiedEnteredValue) === 0 ||
            //     Number(values?.quantity ?? "") === 0
            // ) {
            //     return
            // }

            // setLoadingStatus("apiLoading")

            // const payload = {
            //     // TEMP CHANGES
            //     // portfolioId: "TW100026",
            //     // security: "887",
            //     // quantity: Number(enteredValue ?? ""),
            //     // price: 10, //Rate
            //     // transactionType: "Buy"
            //     // TEMP CHANGES

            //     portfolioId: values?.account ?? "",
            //     security: values?.security?.security ?? "",
            //     quantity: Number(values?.quantity ?? ""),
            //     price: Number(`${formattedModifiedEnteredValue ?? ""}`?.replaceAll(',', '')), //Rate
            //     transactionType: values?.transactionType ?? ""
            // }
            // const response = await (dispatch(getTradeCalculation(payload)) as unknown as Promise<GetTradeCalculationResponseBody>);

            // if (!response?.isSuccess) {
            //     dispatch(showError(response?.message ?? "No Data Available"))
            // }

            // if (response?.isSuccess) {
            // const formatedCharges = (
            //     (!Number.isNaN(Number(response?.tradeCalculationData?.feeTotalCapPcy ?? 0)) ? Number(response?.tradeCalculationData?.feeTotalCapPcy ?? 0) : 0)
            //     +
            //     (!Number.isNaN(Number(response?.tradeCalculationData?.feeTotalExpPcy ?? 0)) ? Number(response?.tradeCalculationData?.feeTotalExpPcy ?? 0) : 0)
            // )?.toLocaleString(locale, {
            //     minimumFractionDigits: 0,
            //     maximumFractionDigits: 2
            // })

            const formattedQuantity = Number(values?.quantity ?? "")
            const formattedCharges = Number(`${values?.charges ?? ""}`?.replaceAll(',', ''))

            let calculatedAmount = Number(`${values?.amount ?? ""}`?.replaceAll(',', ''))

            const areAllFieldsEmpty = `${values?.quantity ?? ''}`.length === 0 && `${enteredValue ?? ""}`.length === 0 && `${values?.charges ?? ""}`.length === 0

            // Formula to calculate amount =>
            // Transaction Type: Buy => (Quantity * rate) + charges 
            // Transaction Type: Sell => (Quantity * rate) - charges

            if (!Number.isNaN(Number(enteredValue)) &&
                !Number.isNaN(Number(formattedQuantity)) &&
                !Number.isNaN(Number(formattedCharges))
            ) {
                if (values.transactionType === "Buy") {
                    calculatedAmount = (formattedQuantity * Number(`${formattedModifiedEnteredValue ?? ""}`?.replaceAll(',', ''))) + formattedCharges
                }
                if (values?.transactionType === "Sell") {
                    calculatedAmount = (formattedQuantity * Number(`${formattedModifiedEnteredValue ?? ""}`?.replaceAll(',', ''))) - formattedCharges
                }
            }

            resetForm({
                values: {
                    ...values,
                    rate: enteredValue,
                    // tradeCalculationData: response?.tradeCalculationData ?? {},
                    amount: areAllFieldsEmpty
                        ? ""
                        : Number(calculatedAmount)?.toLocaleString(locale, {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 2
                        })
                    // amount: (!Number.isNaN(Number(response?.tradeCalculationData?.netAmountTcy ?? 0)) ? Number(response?.tradeCalculationData?.netAmountTcy ?? 0) : 0)?.toLocaleString(locale, {
                    //     minimumFractionDigits: 0,
                    //     maximumFractionDigits: 2
                    // }),
                    // charges: formatedCharges
                }
            })
            // }
        } catch (error) {
            console.log((error as Error)?.message ?? "");
        } finally {
            setLoadingStatus("")
        }
    }

    const handleChargesChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const { target: fieldTarget } = event;
        const { value: enteredValue } = fieldTarget;

        // Formula to calculate amount =>
        // Transaction Type: Buy => (Quantity * rate) + charges 
        // Transaction Type: Sell => (Quantity * rate) - charges

        const formattedModifiedEnteredValue = Number(enteredValue ?? "")?.toLocaleString(locale, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        })

        const formattedQuantity = Number(values?.quantity ?? "")
        const formattedRate = Number(`${values?.rate ?? ""}`?.replaceAll(',', ''))

        let calculatedAmount = Number(`${values?.amount ?? ""}`?.replaceAll(',', ''))

        const areAllFieldsEmpty = `${values?.quantity ?? ''}`.length === 0 && `${values?.rate ?? ""}`.length === 0 && `${enteredValue ?? ""}`.length === 0

        if (
            !Number.isNaN(Number(enteredValue)) &&
            !Number.isNaN(Number(formattedQuantity)) &&
            !Number.isNaN(Number(formattedRate))
        ) {
            if (values.transactionType === "Buy") {
                calculatedAmount = (formattedQuantity * formattedRate) + Number(`${formattedModifiedEnteredValue ?? ""}`?.replaceAll(',', ''))
            }
            if (values?.transactionType === "Sell") {
                calculatedAmount = (formattedQuantity * formattedRate) - Number(`${formattedModifiedEnteredValue ?? ""}`?.replaceAll(',', ''))
            }
        }

        resetForm({
            values: {
                ...values,
                charges: event.target.value,
                amount: areAllFieldsEmpty
                    ? ""
                    : Number(calculatedAmount)?.toLocaleString(locale, {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 2
                    })
            }
        })
    }

    const handleChargesOnBlur = async (event: React.ChangeEvent<any>) => {

        setTouched({ charges: true }, true)

        const { target: fieldTarget } = event;
        const { value: enteredValue } = fieldTarget;

        const modifiedEnteredValue = enteredValue?.trim() ?? ""

        if (
            (Number.isNaN(Number(modifiedEnteredValue))) ||
            modifiedEnteredValue.length === 0
        ) {
            return
        }

        const formattedModifiedEnteredValue = Number(modifiedEnteredValue ?? "")?.toLocaleString(locale, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        })

        await setFieldValue("charges", formattedModifiedEnteredValue)

        setTouched({ amount: true }, true)
    }

    const handleCounterPartyChange = (selectedObj: Record<string, any>) => {
        resetForm({
            values: {
                ...values,
                counterParty: selectedObj,
                settlementBankNumber: selectedObj
                    ? {
                        ...(selectedObj?.banks?.[0] ?? {}),
                        label: selectedObj?.banks?.[0]?.bankAccNo ?? "",
                        value: selectedObj?.banks?.[0]?.bankAccNo ?? ""
                    }
                    : null,
                settlementBank: selectedObj?.banks?.[0]?.bankName ?? "",
                settlementBankIfsc: selectedObj?.banks?.[0]?.ifscCode ?? "",
            }
        })
    }

    const refactoredAmount = `${values?.amount ?? ""}`?.replaceAll(',', '')
    const refactoredCharges = `${values?.charges ?? ""}`?.replaceAll(',', '')
    const refactoredRate = `${values?.rate ?? ""}`?.replaceAll(',', '')
    const refactoredQuantitySaleable = !Number.isNaN(Number(values?.security?.qtySaleable ?? 0)) ? Number(values?.security?.qtySaleable ?? 0) : 0

    return (
        <Grid
            container
            columnSpacing={3}
        >
            {/* <Grid item xs={12} lg={4}>
                <MFTextField
                    name="orderNumber"
                    label="Order Number"
                    placeholder=""
                />
            </Grid> */}
            <Grid item xs={12} lg={4}>
                <TextDatePicker
                    name="orderDate"
                    label="Order Date *"
                    placeholder=""
                    maxDate={
                        businessDate ?
                            dayjs(businessDate, "DD/MM/YYYY").toDate() :
                            new Date()
                    }
                    customHandleChange={handleOrderDateChange}
                    disabled={isLoading}
                />
            </Grid>
            <Grid item xs={12} lg={4}>
                <MFSelectField
                    name="transactionType"
                    label="Transaction Type *"
                    items={[
                        { name: "Buy" },
                        { name: "Sell" } //call holding api
                    ].map((obj) => ({
                        key: obj.name,
                        value: obj.name,
                    }))}
                    disabled={isLoading || !values?.clientName}
                    onChange={handleTransactionTypeChange}
                />
            </Grid>
            <Grid item xs={12} lg={4}>
                <FormikSearchDropdown
                    name="security"
                    label="Security *"
                    options={securitiesData?.securities?.map((obj: Record<string, any>) => ({
                        ...obj,
                        label: obj?.securityName ?? "",
                        value: obj?.security ?? ""
                    })) ?? []}
                    fetchData={fetchSecuritiesData}
                    disabled={isLoading || !values?.transactionType}
                    onChange={handleSecurityChange}
                    filterOptions={(x) => x}
                />
            </Grid>
            <Grid item xs={12} lg={4}>
                <MFTextField
                    name="issuer"
                    label="Issuer"
                    placeholder=""
                    disabled={true}
                    value={values?.issuer ?? ""}
                />
            </Grid>
            <Grid item xs={12} lg={4}>
                <FormikSearchDropdown
                    name="counterParty"
                    label="Counter Party *"
                    options={(counterPartyList?.counterPartyList ?? [])?.map((obj: Record<string, any>) => ({
                        ...obj,
                        label: obj?.description ?? "",
                        value: obj?.identifier ?? ""
                    })) ?? []}
                    fetchData={fetchCounterPartyList}
                    disabled={isLoading || !values?.security}
                    filterOptions={(x) => x}
                    onChange={handleCounterPartyChange}
                />
            </Grid>
            <Grid item xs={12} lg={4} sx={{ position: "relative" }}>
                {values?.transactionType === "Sell" && (
                    <Typography
                        variant="overline_400"
                        sx={{
                            position: "absolute",
                            top: "-5px",
                            right: "0px"
                        }}
                    >
                        Available Quantity: {refactoredQuantitySaleable}
                    </Typography>
                )}
                <MFTextField
                    name="quantity"
                    label="Quantity *"
                    placeholder=""
                    disabled={isLoading || !values?.security}
                    onKeyDown={preventSpecialCharacters}
                    value={values?.quantity ?? ""}
                    onChange={handleQuantityOnChange}
                />
            </Grid>
            <Grid item xs={12} lg={4}>
                <MFTextField
                    name="rate"
                    label="Rate *"
                    placeholder=""
                    startAdornment={values?.rate ? (
                        <Typography
                            variant='body_500'
                            sx={(theme: Theme) => ({
                                color: (isLoading || !values?.security) ? theme.palette.text.secondary : theme.palette.text.primary
                            })}
                        >
                            {String.fromCharCode(parseInt(currencySymbol, 16))}
                        </Typography>
                    ) : undefined}
                    sx={{
                        '&.MuiOutlinedInput-root': {
                            "& fieldset>legend": {
                                fontSize: "0.78em",
                            }
                        }
                    }}
                    onKeyDown={allowDecimalNumbers}
                    disabled={isLoading || !values?.security}
                    onPaste={(event: React.ClipboardEvent<HTMLInputElement>) => handleTextPaste(event, "rate")}
                    formatCurrency
                    formatCurrencyLocaleOptions={{
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 4
                    }}
                    value={values?.rate ?? ""}
                    onChange={handleRateOnChange}
                />
                <CurrencyConversionToWords value={refactoredRate} />
            </Grid>
            <Grid item xs={12} lg={4}>
                <MFTextField
                    name="charges"
                    label="Charges *"
                    placeholder=""
                    startAdornment={values?.charges ? (
                        <Typography
                            variant='body_500'
                            sx={(theme: Theme) => ({
                                color: (isLoading || !values?.security) ? theme.palette.text.secondary : theme.palette.text.primary
                            })}
                        >
                            {String.fromCharCode(parseInt(currencySymbol, 16))}
                        </Typography>
                    ) : undefined}
                    sx={{
                        '&.MuiOutlinedInput-root': {
                            "& fieldset>legend": {
                                fontSize: "0.78em",
                            }
                        }
                    }}
                    onKeyDown={allowDecimalNumbers}
                    disabled={isLoading || !values?.security}
                    onPaste={(event: React.ClipboardEvent<HTMLInputElement>) => handleTextPaste(event, "charges")}
                    formatCurrency
                    formatCurrencyLocaleOptions={{
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 2
                    }}
                    value={values?.charges ?? ""}
                    onChange={handleChargesChange}
                    onBlur={handleChargesOnBlur}
                />
                <CurrencyConversionToWords value={refactoredCharges} />
            </Grid>
            <Grid item xs={12} lg={4}>
                <MFTextField
                    name="amount"
                    label="Amount *"
                    placeholder=""
                    startAdornment={values?.amount ? (
                        <Typography
                            variant='body_500'
                            sx={(theme: Theme) => ({
                                color: (isLoading || !values?.security) ? theme.palette.text.secondary : theme.palette.text.primary
                            })}
                        >
                            {String.fromCharCode(parseInt(currencySymbol, 16))}
                        </Typography>
                    ) : undefined}
                    sx={{
                        '&.MuiOutlinedInput-root': {
                            "& fieldset>legend": {
                                fontSize: "0.78em",
                            }
                        }
                    }}
                    onKeyDown={allowDecimalNumbers}
                    disabled={isLoading || !values?.security}
                    formatCurrency
                    formatCurrencyLocaleOptions={{
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 2
                    }}
                    onPaste={(event: React.ClipboardEvent<HTMLInputElement>) => handleTextPaste(event, "amount")}
                    value={values?.amount ?? ""}
                />
                <CurrencyConversionToWords value={refactoredAmount} />
            </Grid>
            <Grid item xs={12}>
                <MFTextField
                    name="remarks"
                    label="Remarks *"
                    placeholder=""
                    multiline
                    inputProps={{ maxLength: 200 }}
                    value={values?.remarks ?? ""}
                    disabled={isLoading}
                />
                <Typography
                    variant="overline_400"
                    sx={(theme: Theme) => ({
                        textAlign: "end",
                        color: theme.palette.text.secondary,
                        marginTop: "-10px"
                    })}
                >
                    Max 200 characters
                </Typography>
            </Grid>
        </Grid>
    )
}